export default __webpack_public_path__ + "static/media/setion03_kv01.304222a3.png";